export const getSrcSkyProxy = (url: string, width: number[], params?: { onlySrc?: boolean; square?: boolean }) => {
	const skyProxySrc = width?.map(
		(width) =>
			`https://skyproxy.superkoders.rocks/pixii/?url=${encodeURIComponent(url)}&format=auto&w=${width}${
				params?.square ? `&h=${width}` : ``
			}${params?.onlySrc ? `` : ` ${width}w`}`
	);
	return skyProxySrc?.toString();
};
